import { useCallback } from 'react';

import { ActionCategory, PossibleAction } from '../../types/google-analytics-types.types';
import { createGAEvent } from '../../utils/create-google-analytic-event.util';

export const useClick = (action: PossibleAction) => {
  return useCallback(
    (label?: string) =>
      createGAEvent({
        category: ActionCategory.USER_ACTIONS,
        action,
        label,
      }),
    [action],
  );
};
